<script>
  import { PlayFill } from "svelte-bootstrap-icons/lib/";
  import { tracks, playingTrack } from "../stores.js";
  import { fade } from "svelte/transition";

  function formatTime(rawTime) {
    const date = new Date(Math.round(rawTime) * 1000);
    return date.toUTCString().split(" ")[4];
  }

  function formatDate(rawDate) {
    const date = new Date(Math.round(rawDate) * 1000);
    return date.toLocaleDateString();
  }

  function setPlaying(track) {
    playingTrack.set(track);
  }
</script>

<style>

  .control {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
    transition: all 0.5s ease;
  }

  .control:hover {
    background-color: rgba(0, 0, 0, 0.25);
  }

  .imgContainer:after {
    content: "";
    display: block;
    padding-bottom: 90%;
  }

  .imgContent {
    position: absolute;
    width: 100%;
    height: 100%;
    transition: all 0.5s ease;
  }

  .imgContent:hover {
    transform: scale(1.01);
  }

  .imgContent img {
    width: 100%;
    height: 90%;
    object-fit: cover;
    border-radius: 100px;
  }

  .title {
    font-size: 1.2rem;
    font-weight: 400;
  }
  .author {
    font-size: 0.8rem;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-weight: 400;
  }
  .metadata {
    padding: 30px;
  }

  .tracks {
    margin-top: 30px;
  }

  @media (min-width: 768px) {
    .title {
      font-size: 1.3rem;
    }
    .author {
      font-size: 0.8rem;
    }
    .metadata {
      padding: 30px;
    }

    .imgContent {
      position: absolute;
      width: 100%;
      height: 100%;
      transition: all 0.5s ease;
    }

    .imgContent img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 25%;
    }

    .imgContainer:after {
      content: "";
      display: block;
      padding-bottom: 100%;
    }

    .tracks {
      padding-top: 0px;
    }
  }
</style>

<div class="row p-0 pt-md-0">
  {#if $tracks.length}
    {#each $tracks as track}
      <div class="col-12 col-md-6 col-lg-4 col-xl-3">
        <div class="my-md-3 my-0 border-primary">
          <div class="row tracks">
            <div class="col-12 col-md-12">
              <div class="position-relative imgContainer">
                <div class="imgContent">
                <div class="meatadata control justify-content-center text-center p-md-4 p-4">
                  <h6 class="author text-center">{track.identifierTitle}</h6>
                  <h4 class="title text-center">{track.title}</h4>
                </div>

                  <img
                    src={`https://archive.org/download/${track.identifier}/${track.cover.name}`}
                    alt="track cover"
                    class="lazy"
                    loading="lazy" />

                    {#if ($playingTrack && $playingTrack.md5) !== track.md5}

                    <div
                      transition:fade
                      class="control d-flex align-items-center justify-content-center text-center">

                      <button
                        class="btn btn-outline-light"
                        on:click={() => setPlaying(track)}><PlayFill
                        width="50px"
                        height="50px" />
                      </button>
                    </div>


                  {/if}
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    {/each}
  {/if}
</div>
